<template>
  <section class="category-page-section">
    <div class="wrapper">
      <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="title-banner">
              <div class="title-content">
                <h1 :class="{ 'tamil-title-h2': selectedLanguage === 'ta', 'title-h2': selectedLanguage !== 'ta' }">{{ translations.marketPrice }}</h1>
                <div class="address-section">
                  <img
                    src="../assets/images/category-page-home-icon.svg"
                    alt="home page"
                    loading="lazy"
                  />
                  <p class="footer-add"><a href="/"> &nbsp;{{ translations.home_lite }}</a></p>
                  <img
                    src="../assets/images/next-page.svg"
                    alt="next-page"
                    class="next-page"
                    loading="lazy"
                  />
                  <p class="footer-add">{{ translations.marketPrice }}</p>
                  <!-- <img src="../assets/images/next-page.svg" alt="" class="next-page">
                                <p class="footer-add">&nbsp;&nbsp;Dairy Product </p> -->
                </div>
                <!-- <img src="../assets/images/category-page-home-icon.svg" alt=""><span>Home</span> &nbsp; <img src="../assets/images/next-page.svg" alt=""> &nbsp;<span>Product Category </span> -->
              </div>
            </div>
          </div>
           <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="right-ads-category">
              <Adsense
    style="display:inline-block;width:100%;height:220px"
     data-ad-client="ca-pub-1763856178878021"
     data-ad-slot="2634101883">
</Adsense>
            </div> 
          </div>
        </div>
      </div>
<!-- <BellowHeader /> -->
      <section class="marketprice-select">
        <h1>{{ selectedLanguage === "en" ? 
    this.$route.params?.categoryName?.replace(/-/g, ' ')?.replace(/\b\w/g, char => char.toUpperCase()) : 
    selectedProduct
  }} 
 {{ selectedLanguage === "en" 
  ? translations.marketPrice + (isToday(created) ? ' ' + translations.today : '') 
  : translations.today + ' ' + translations.marketPrice + (isToday(created) ? '' : '') 
}}   {{ selectedLanguage === "en" ? 
    (this.$route.params.location?.startsWith('-') ? 
      this.$route.params.location?.split('-')[1]?.replace(/\b\w/g, char => char.toUpperCase()) || 'Tamilnadu' : 
      this.$route.params?.location?.replace(/\b\w/g, char => char.toUpperCase()) || 'Tamilnadu') : 
    selectedDistrict ?? translations.tamilnadu
  }}
<!-- Market Price today in
  {{
    (this.$route.params.location?.startsWith('-') ? 
      this.$route.params.location?.split('-')[1]?.replace(/\b\w/g, char => char.toUpperCase()) || 'Tamilnadu' : 
      this.$route.params?.location?.replace(/\b\w/g, char => char.toUpperCase()) || 'Tamilnadu') 
  }} -->
  </h1>
  
         <div v-if="content" class="content ">
          <p>{{ content }}</p>
        </div>
        <div class="row">
          <div class="col-lg-10 col-md-10">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="catgory">
                  <h5>{{ translations.categories }}</h5>
                  <div class="div">
                    <div class="category-icon">
                      <img
                        src="../assets/images/MP-select-icon.svg"
                        alt="mp-slect"
                        class="category-icon-img"
                        loading="lazy"
                      />
                    </div>
                    <div class=" select-section safari-only">
                      <select :class="{ 'tamil-font': selectedLanguage === 'ta', 'selec': selectedLanguage !== 'ta' }" v-model="selectedCategory" searchable>
          <option value="0" disabled >{{ translations.selectProduct }}</option>
          <option v-for="category in categories" :key="category.category_id" :value="category.category_id" class="listoption">
            {{ selectedLanguage === "en" ? category.category_name : category.tn_name }}
          </option>
        </select> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="catgory">
                  <h5>{{ translations.district }}</h5>
                  <div class="div">
                    <div class="category-icon">
                      <img
                        src="../assets/images/MP-select-icon.svg"
                        alt="mp-slect"
                        class="category-icon-img"
                        loading="lazy"
                      />
                    </div>
                     <div class=" select-section">
                         <select  :class="{ 'tamil-font': selectedLanguage === 'ta', 'selec': selectedLanguage !== 'ta' }" v-model="selectedMarket" searchable :disabled="!markets.length">
          <option value="0" disabled >{{ translations.selectDist1 }}</option>
          <option v-for="market in markets" :key="market.market_id" :value="market.market_id"  class="listoption"
          >
            {{ selectedLanguage === "en" ? market.market_name : market.tn_name }}
          </option>
        </select> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="catgory">
                  <h5>{{ translations.citys }}</h5>
                  <div class="div">
                    <div class="category-icon">
                      <img
                        src="../assets/images/MP-select-icon.svg"
                        alt="mp-select"
                        class="category-icon-img"
                        loading="lazy"
                      />
                    </div>
                     <div class=" select-section">
                      <select :class="{ 'tamil-font': selectedLanguage === 'ta', 'selec': selectedLanguage !== 'ta' }" v-model="selectedPlace" :disabled="!placeData.length">
          <option value="0">{{ translations.all }}</option>
          <option v-for="place in placeData" :key="place.market_place_id" :value="place.market_place_id"  class="listoption">
            {{ selectedLanguage === "en" ? place.place : place.tn_place }}
          </option>
        </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="catgory">
                  <h5>{{ translations.date }}</h5>
                  <div class="div">
                    <div class="category-icon">
                      <img
                        src="../assets/images/MP-select-icon.svg"
                        alt="mp-select"
                        class="category-icon-img"
                        loading="lazy"
                      />
                    </div>
                    <div class="select-section">
                      <input
                        type="date"
                        v-model="created"
                        :max="currentDate"
                        :min="minDate"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="" @click="searchMarketData">
              <button
                class="catgory-button"
                :disabled="selectedMarket == '0' || selectedCategory == '0'"
                :class="{
                  'disabled-red':
                    selectedMarket == '0' || selectedCategory == '0',
                }"
              >
                {{translations.search}}
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="row">
          
            <div class="col-lg-12 col-md-12 col-sm-12">
               <h2 >{{ translations.trendMp }}</h2>
              <div class="table-container" ref="MarketTable">
                <div v-if="isLoading">
                      <!-- <p>{{ logValue(isLoading) }}</p> -->

                  <!-- Shimmer effect for loading -->
                  <div v-for="index in 6" :key="index" class="container">
                    <p class="shimmer-line" style="height: 40px"></p>
                    <p class="shimmer-line" style="height: 40px"></p>
                    <p class="shimmer-line" style="height: 40px"></p>
                  </div>
                </div>
                <div  v-else-if="sublistData.length || (tumpData.length && !this.$route.params.location) ">
                  <div class="d-sm-none">
                  <table>
                    <tr>
                      <th>{{translations.category}}</th>
                      <th class="price-unit">{{translations.price}}/{{ translations.units }}</th>
                    </tr>
                    <tr
                      v-for="date in sublistData.length
                        ? sublistData
                        : tumpData"
                      :key="date.uniqueId"
                    >
                      <td>
                        <div class="category-name-table">
                          <!-- <img src="../assets/images/vegetable.png" alt="" class="veg-icon"/> -->
                          <p>
                            {{
                              selectedLanguage === "en"
                                ? date.sub_category_name
                                : date.tn_sub_name
                            }} 
                            <br>
                            <span>
       {{
                          selectedLanguage === "en" ? date.place : date.tn_place
                        }}
                            </span>
                      
                            <!-- {{date.sub_category_name}} -->
                          </p>
                        </div>
                      </td>
                      <td class="amt">
                        Rs. {{ date.price }}/{{
                          selectedLanguage === "en"
                            ? date.quantity_type
                            : date.quantity_type_tamil
                        }} 
                        <br>
                         <router-link :to="{
                      name: 'AllRecent',
                      params: {
                        name: date.sub_category_name.trim().replace(/\s+/g, '-').toLowerCase() || '',
                        categoryName: date.category_name.replace(/\s+/g, '-').toLowerCase(),
                        location: '-' + date.market_name.replace(/\s+/g, '-').toLowerCase(),
                        city: date.place.replace(/\s+/g, '-').toLowerCase(),
                      },
                    }" target="_blank">
                          <p class="his-btn">
                          
                              <svg width="24" height="18" viewBox="0 0 24 21" fill="#000000" xmlns="http://www.w3.org/2000/svg">
<path d="M1.62695 16.3227V20.2768C1.62695 20.5174 1.81925 20.7178 2.06086 20.7178H5.06861C5.30529 20.7178 5.50252 20.5224 5.50252 20.2768V13.3207L3.3182 15.5409C2.85471 16.0069 2.26302 16.2776 1.62695 16.3227Z" fill="white"/>
<path d="M7.00146 13.2707V20.2769C7.00146 20.5174 7.19376 20.7179 7.43537 20.7179H10.4431C10.6798 20.7179 10.877 20.5224 10.877 20.2769V16.1523C10.1917 16.1373 9.55066 15.8617 9.06745 15.3705L7.00146 13.2707Z" fill="white"/>
<path d="M12.376 15.7163V20.2769C12.376 20.5174 12.5683 20.7179 12.8099 20.7179H15.8176C16.0543 20.7179 16.2515 20.5224 16.2515 20.2769V11.8624L12.805 15.3655C12.6718 15.5008 12.5288 15.6161 12.376 15.7163Z" fill="white"/>
<path d="M21.3356 6.69043L17.751 10.3338V20.2768C17.751 20.5174 17.9433 20.7178 18.1849 20.7178H21.1926C21.4293 20.7178 21.6265 20.5224 21.6265 20.2768V6.96607C21.5279 6.88087 21.454 6.8057 21.3997 6.75558L21.3356 6.69043Z" fill="white"/>
<path d="M23.7958 0.235544C23.6528 0.080185 23.4358 0 23.1597 0C23.135 0 23.1055 0 23.0808 0C21.6805 0.0651505 20.2851 0.135313 18.8847 0.200463C18.6974 0.210486 18.441 0.220509 18.2388 0.425984C18.1747 0.491134 18.1254 0.566308 18.086 0.656516C17.8789 1.11257 18.1698 1.40825 18.3078 1.54858L18.6579 1.90941C18.8995 2.15999 19.1461 2.41057 19.3926 2.65613L10.9315 11.261L7.12986 7.39708C6.90304 7.16655 6.59733 7.03625 6.27191 7.03625C5.94648 7.03625 5.6457 7.16655 5.41889 7.39708L0.355014 12.539C-0.118338 13.0201 -0.118338 13.7969 0.355014 14.278L0.581828 14.5085C0.808642 14.739 1.11435 14.8693 1.43978 14.8693C1.76521 14.8693 2.06598 14.739 2.2928 14.5085L6.27191 10.4642L10.0735 14.3281C10.3003 14.5586 10.606 14.6889 10.9315 14.6889C11.2569 14.6889 11.5577 14.5586 11.7894 14.3281L21.3353 4.62568L22.4152 5.71821C22.5434 5.84851 22.7209 6.02892 22.9921 6.02892C23.1055 6.02892 23.2189 5.99886 23.3372 5.9337C23.4161 5.8886 23.4851 5.83848 23.5443 5.77835C23.7563 5.56285 23.7958 5.28721 23.8056 5.07171C23.8451 4.14958 23.8895 3.22745 23.9338 2.30031L23.9979 0.912106C24.0127 0.621435 23.9486 0.395914 23.7958 0.235544Z" fill="white"/>
</svg>
                            &nbsp;{{ translations.view }}
                         
                        </p>
                         </router-link>
                        </td>
                    </tr>
                  </table>
                  </div>
                  <div class="table-1-web d-none d-sm-block">
                  <table>
                    <tr>
                      <th>{{translations.category}}</th>
                      <th >{{translations.selectdist}}</th>
                      <th >{{translations.city}}</th>
                      <th>{{translations.price}}</th>
                      <th>{{ translations.units }}</th>
                      <th>{{ translations.history }}</th>
                    </tr>
                    <tr
                      v-for="date in sublistData.length
                        ? sublistData
                        : tumpData"
                      :key="date.uniqueId"
                    >
                      <td>
                        <div class="category-name-table">
                          <img src="../assets/images/vegetable.png" alt="vegetable" class="veg-icon" loading="lazy"/>
                          <p>
                            {{
                              selectedLanguage === "en"
                                ? date.sub_category_name
                                : date.tn_sub_name
                            }}
                            <!-- {{date.sub_category_name}} -->
                          </p>
                        </div>
                      </td>
                      <td>
                        {{
                          selectedLanguage === "en"
                            ? date.market_name
                            : date.tn_name
                        }}
                        <!-- {{date.market_name}} -->
                      </td>
                      <td>
                        {{
                          selectedLanguage === "en" ? date.place : date.tn_place
                        }}
                        <!-- {{date.place}} -->
                      </td>
                      <td class="amt">
                        Rs. {{ date.price }}
                        </td>
                      <td class="weight">
                        {{
                          selectedLanguage === "en"
                            ? date.quantity_type
                            : date.quantity_type_tamil
                        }}
                        <!-- {{date.quantity_type}} -->
                      </td>
                      <td>
                        <router-link :to="{
                      name: 'AllRecent',
                      params: {
                        name: date.sub_category_name.trim().replace(/\s+/g, '-').toLowerCase() || '',
                        categoryName: date.category_name.replace(/\s+/g, '-').toLowerCase(),
                        location: '-' + date.market_name.replace(/\s+/g, '-').toLowerCase(),
                        city: date.place.replace(/\s+/g, '-').toLowerCase(),
                      },
                    }" target="_blank">
                          <button class="his-btn">
                          
                            <img
                              src="../assets/images/history.svg"
                              alt="history-btn"
                              class="history-price"
                              loading="lazy"
                            />
                            &nbsp;{{ translations.view }}
                         
                        </button>
                         </router-link>
                      </td>
                    </tr>
                  </table>
                  </div>
                </div>
                   <div v-else>
             <div class="nodata-img">
              <img class="" src="../assets/images/emptypro.webp" loading="lazy" alt="empty">
            </div>
              <h2 class="my-3 no-data">
                {{ translations.no_data_market }} 
                <!-- Market price is not available for selected date -->
               </h2>
               
               <p class="no-data-para">
                {{ translations.no_data_found }}
                <!-- We're sorry, but the Market price not available for the selected date filter. Please check back later. You can browse our website to find alternative market price categories. -->
                </p>
           
          </div> 
              </div>
                 
              <div class="page-nation" v-if="sublistData.length">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6" >
                    <div class="show-page">
                      <p v-if="currentPage < totalPages">Showing {{ currentPage }} / {{ totalPages }} of {{ totalItems }} item(s)</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="page-btns">
                       <nav >
      <ul class="pagination">
    <!-- First Page -->
    <li :class="{ disabled: currentPage === 1 }">
      <a @click="onPageChange(1)" aria-label="First">
            <span aria-hidden="true">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </span>
      </a>
    </li>

    <!-- Previous Page -->
    <li :class="{ disabled: currentPage === 1 }">
      <a @click="onPageChange(currentPage - 1)" aria-label="Previous">
            <span aria-hidden="true">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </span>
      </a>
    </li>

        <li :class="{ active: currentPage === pageNumber }" v-for="pageNumber in pageNumbers" :key="pageNumber">
          <a @click="onPageChange(pageNumber)">{{ pageNumber }}</a>
    </li>
        <!-- Next Page Button -->
    <li :class="{ disabled: currentPage === totalPages }">
      <a @click="onPageChange(currentPage + 1)" aria-label="Next">
            <span aria-hidden="true">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </span>
      </a>
    </li>

        <!-- Last Page Button -->
    <li :class="{ disabled: currentPage === totalPages }">
      <a @click="onPageChange(totalPages)" aria-label="Last">
            <span aria-hidden="true">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </span>
      </a>
    </li>
  </ul>
</nav>
                    </div>
                  
                  </div>
                </div>
                
              </div>
                    <h3 class="todays-head mt-3" v-if="Newmarket.length > 1">
  {{ translations.todays }} 
  {{ selectedLanguage === 'en' ? 
    this.$route.params?.categoryName?.replace(/-/g, ' ')?.replace(/\b\w/g, char => char.toUpperCase()) : 
    selectedProduct 
  }} 
  {{ translations.marketPrices1 }} {{ translations.tamilnadu }}
</h3>
<div class="market-container">
  <div
    v-for="(market, index) in Newmarket"
    :key="market.market_id"
    :value="market.market_id"
    class="inter-links"
  >
    <span
    
      @click="navigateToMarketPrice(market)"  
    >
      {{ selectedLanguage === 'en' ? market.market_name : market.tn_name }} {{ 
    
      }} {{ translations.marketPrice  }}
      <span v-if="index !== Newmarket.length - 1"> | </span>
    </span>
  </div>
</div>
             <div class="disclaimer">
      <p class="text-center my-3 container" v-if="disclaimer"><strong>Disclaimer:</strong> {{ disclaimer }}</p>
    </div>
            </div>

          </div>
        </div>
      </section>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 bottom-ads">
      <!-- <AboveFooter /> -->
    </div>
  </section>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { disableScroll } from "../router/index";
import { useItemStore, useUserStore } from "../stores/userStore";
import { mapActions, mapState } from "pinia";
// import AboveFooter from "./AboveFooter.vue";
// import BellowHeader from './BellowHeader.vue';

import { en, ta } from "../translations";

export default {
  props: {
    selectedLanguage: String
  },
  data() {
    return {
      marketName: null,
      categoryName: null,
      sublistData: [],
      isLoading: true,
      place: null,
      totalItems: 0,
      itemsPerPage: 10, // Example: set the default number of items per page
      currentPage: 1,
      totalPages: 0, // Add this property to store the total number of pages
      selectedMarket: "0",
      markets: [],
      Newmarket: [],
      tumpData: [],
      selectedPlace: "0",
      placeData: [],
      selectedCategory: "0",
      categories: [],
      dates: [],
      chooseDate: "",
      // created: this.selectedDate || new Date().toISOString().split('T')[0],
      isFreshPage: this.$route.params.location ? true : false,
      created: new Date().toISOString().split("T")[0],
      currentDate: new Date().toISOString().split("T")[0],
      minDate: this.getMinDate(),
      selectedProduct: "",
      selectedDistrict: "",
      searchedPlace: "0",
      subListDataFetched: false,
      isPlaceDataFetched: false,
    };
  },
  components: {
    // BellowHeader,
    // AboveFooter,
  },
  head() {
    return {
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://vayalagro.com/market-price",
            url: "https://vayalagro.com/market-price",
            name: "Market Prices in Tamil Nadu",
            description:
              "Get the latest market prices for various agricultural products and livestock in Tamil Nadu. Stay informed for better trading decisions.",
            inLanguage: "en-US",
            datePublished: "2024-10-17T00:00:00+00:00",
            dateModified: "2024-10-21T00:00:00+00:00",
            breadcrumb: {
              "@type": "BreadcrumbList",
              "@id": "https://vayalagro.com/market-price/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://vayalagro.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Market Prices",
                  item: "https://vayalagro.com/market-price",
                },
              ],
            },
          },
        },
      ],
    };
  },
  computed: {
    translations() {
      return this.selectedLanguage === "en" ? en : ta;
    },
    ...mapState(useItemStore, ["categoryId", "subCategoryId"]),
    ...mapState(useUserStore, ["marketId", "marketPlaceId"]),
    selectedDate() {
      return this.$router.history?.state?.selectedDate || false;
    },

    formatDate() {
      return (date) => moment(date).format("DD-MM-YYYY");
    },

    sublistDate() {
      return (date) => date.split("/").join("-");
    },
    pageNumbers() {
      const visiblePageCount = 3; // Number of page numbers to display
      const startPage = Math.max(
        1,
        this.currentPage - Math.floor(visiblePageCount / 2)
      );
      const endPage = Math.min(
        this.totalPages,
        startPage + visiblePageCount - 1
      );

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
  },
  beforeCreate() {
    if (!Object.keys(this.$route.params).length) {
      this.$route.params = {
        location: "",
        categoryName: "",
        city: "",
        created: "",
        categoryId: "",
      };
      if (!this.selectedCategory) this.selectedCategory = "0";
      if (!this.selectedMarket) this.selectedMarket = "0";
      if (!this.selectedPlace) {
        // console.log('mpId to 0 (0)')
        this.selectedPlace = "0";
      }
    }
    if (this.selectedDate) {
      this.created = this.selectedDate;
      disableScroll();
      console.log("created set from state!", this.selectedDate);
    }
  },
  watch: {
    categoryId(newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.fetchMarketData();
        // this.updateMarketPlaceId(this.$route.params?.city?.replace(/-/g,' '),this.categoryId,this.marketId)
      }
    },
    subCategoryId(newVal) {
      console.log("SubCategory ID changed:", newVal);
    },
    marketId(newVal, oldVal) {
      // console.log('Market ID changed:', newVal);
      if (
        newVal !== oldVal &&
        this.marketId != "0" &&
        this.categoryId != "0" &&
        !this.isPlaceDataFetched
      )
        this.fetchPlaceData();
    },
    marketPlaceId(newVal, oldVal) {
      console.log("Marketplace ID changed from:", oldVal, " to ", newVal);
    },
    // Watch for changes in the route parameters
    "$route.params": {
      handler(newParams, oldParams) {
        // console.log('route params watcher called...')
        this.updateMetaTags();
        this.handleRouteChange(newParams, oldParams);
      },
      deep: true,
      immediate: true,
    },
    selectedMarket: {
      handler(newVal, oldVal) {
        console.log(
          "selectedMarket watcher called... new:",
          newVal,
          "old:",
          oldVal
        );
        if (this.selectedMarket != this.marketId) {
          // console.log("mId changing...")
          this.updateMarketId(this.selectedMarket);
        } else {
          // console.log("not changed")
        }
        if (
          !this.subListDataFetched &&
          this.$route.params.categoryName &&
          this.selectedCategory != "0" &&
          this.selectedMarket != "0" &&
          !this.$route.params?.city
        ) {
          // console.log("line-454", this.$route.params)
          this.fetchSublistData();
          this.isFreshPage = false;
        } else {
          // console.log("mId not changed here", this.subListDataFetched, )
        }
        this.currentPage = 1; // Reset the current page to 1 when the market changes
        if (this.selectedMarket != "0") {
          // this.selectedPlace = '0';
          this.fetchPlaceData();
        }
      },
      immediate: true,
    },
    selectedPlace: {
      handler(newPlace, oldPlace) {
        // console.log('newPlace:',newPlace,"oldPlace:",oldPlace,'marketPlaceId',this.marketPlaceId)
        if (this.selectedPlace != this.marketPlaceId) {
          // console.log("mpId changing...")
          this.updateMarketPlaceId(newPlace);

          if (
            !this.subListDataFetched &&
            this.$route.params.categoryName &&
            this.selectedPlace != "0" &&
            Object.keys(this.$route.params).length &&
            newPlace !== oldPlace &&
            this.categoryId &&
            this.marketId
          ) {
            // console.log('line reload sublist')
            this.fetchSublistData();

            this.isFreshPage = false;
          } else {
            // console.log('line reload sublist not called')
          }

          this.currentPage = 1; // Reset the current page to 1 when the place changes
        } else {
          // console.log("mpId not changed")
        }
      },
      immediate: true,
    },
    selectedCategory: {
      handler() {
        if (this.selectedCategory != "0") {
          this.fetchMarketData();
        }
        if (this.selectedCategory != this.categoryId) {
          // console.log("cat changing...")
          this.updateCatId(this.selectedCategory);
        } else {
          // console.log("cat not changed")
        }
        this.currentPage = 1;
      },
    },
    created: {
      // when changing date, data should come bcoz we are not passing in url to fetch when search
      handler() {
        if (
          this.selectedCategory &&
          this.selectedCategory != "0" &&
          this.selectedMarket &&
          this.selectedMarket != "0"
        ) {
          console.log("line-498");
          this.fetchSublistData((this.currentPage = 1));
          this.isFreshPage = false;
        }
      },
        

    },
  },
  beforeUnmount() {
    (this.sublistData = []),
      (this.markets = []),
      (this.tumpData = []),
      (this.placeData = []),
      (this.categories = []),
      (this.dates = []);
  },

  async created() {
       console.log("mp-created",this.$route);
    this.fetchCategoryData(true);
    if (this.selectedCategory) {
      await this.fetchMarketData();
    }
    if (this.selectedCategory != "0" && this.selectedMarket != "0") {
      console.log("line-521");
    }

    if (!this.$route.params.location) {
      await this.fetchInitData();
    }
    this.updateMetaTags();
  },

  mounted() {
    this.marketName = this.$route.params?.location;
    this.categoryName = this.$route.params?.categoryName?.replace(/-/g, " ");
  },
  methods: {
     disableBodyScroll() {
      // Disable body scroll when the dropdown is opened
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // Re-enable body scroll when the dropdown is closed
      document.body.style.overflow = "auto";
    },
   logValue(value) {
      console.log("Value:", value);
      return ""; // Prevents the method from rendering anything in the DOM
    },
    ...mapActions(useItemStore, [
      "updateItemId",
      "updateMarketCatId",
      "updateSubCatId",
      "updateCatId",
    ]),
    ...mapActions(useUserStore, [
      "updateMarketId",
      "updateMarketIdByDist",
      "updateMarketPlaceId",
      "updateMarketPlaceIdByCity",
    ]),
    redirectToContact() {
      this.$router.push("/contact");
    },
    updatePaginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      this.paginatedData = this.sublistData.slice(start, end);
    },
    onPageChange(page) {
      this.$nextTick(() => {
        const container = this.$refs.MarketTable;
        if (container) {
          container.scrollIntoView({ behavior: "smooth" });
        }
      });
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        console.log("this.currentPage", this.currentPage);
        this.updatePaginatedData();
      }
      this.fetchSublistData();
    },
    navigateToMarketPrice(market) {
      const categoryName = this.$route.params.categoryName;
      const district = market.market_name;
console.log("categoryName-mp",categoryName,"district",district)
      this.created = new Date().toISOString().split("T")[0];
      console.log("market-data", this.created);

      this.$router.push({
        name: "pricesublist",
        params: {
          categoryName: categoryName,
          location: `-${district}`,
        },
      });
     this.$nextTick(() => {
            const container = this.$refs.MarketTable;
            if (container) {
              container.scrollIntoView({ behavior: "smooth" });
            }
          });
    },

  
    async handleRouteChange(newParams = null) {
      console.log("handleRouteChange");
      

      if (!Object.keys(newParams).length) {
        // console.log("line-624", Object.keys(newParams).length)
        if (!this.selectedCategory) this.selectedCategory = "0";
        if (!this.selectedMarket) this.selectedMarket = "0";
        if (!this.selectedPlace) this.selectedPlace = "0";
        this.fetchInitData();
        this.sublistData = [];
      } else {
        // console.log("line-592",this.selectedCategory,this.selectedMarket)
        await this.fetchMarketData();
        if (this.selectedCategory != "0" && this.selectedMarket != "0") {
          // console.log("line-592")
          this.fetchSublistData();
        }
      }
      this.fetchCategoryData();
    },

    getMinDate() {
      const today = new Date();
      today.setDate(today.getDate() - 30); // Subtract 30 days
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    isToday(date) {
      const today = new Date();
      const todayString = today.toISOString().split("T")[0];
      return date === todayString;
    },
    searchMarketData() {
  console.log("searchMarketData");
  this.isLoading = true;
  var params = {
    ...this.$route.params,
  };

  this.Newmarket = [];

  for (let cat of this.categories) {
    if (cat.category_id == this.selectedCategory) {
      params.categoryName = cat?.category_name?.replace(/\s+/g, '-')?.toLowerCase();
      break;
    }
  }

  for (let district of this.markets) {
    if (district.market_id == this.selectedMarket) {
      params.location = district?.market_name?.replace(/\s+/g, '-')?.toLowerCase();
      break;
    }
  }

  // Only include city if a city is selected
  if (this.selectedPlace != '0') {
    for (let city of this.placeData) {
      if (city.market_place_id == this.selectedPlace) {
        params.city = city?.place?.replace(/\s+/g, '-')?.toLowerCase();
        break;
      }
    }
  }
 else params.city = ''
  // Ensure location starts with a hyphen
  params.location = params.location && params.location[0] == '-' ? params.location : `-${params.location}`;

  this.isFreshPage = true;
  disableScroll();

  this.$nextTick(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    if (mediaQuery.matches) {
      const container = this.$refs.MarketTable;
      if (container) {
        container.scrollIntoView({ behavior: "smooth" });
      }
    }
  });

  // Remove city from params if it's not selected
  if (!params.city) {
    delete params.city;
  }
  if (!this.Newmarket.length) {
              this.Newmarket = [...this.markets];
            } 
  this.$router.push({
    name: 'pricesublist1',
    params,
    state: {
      selectedDate: this.created
    }
  });

  console.log("marketprice-params", this.$route);

  this.currentPage = 1;
  this.isLoading = false;
},

    storeIds(data) {
      if (data.sub_category_id) {
        if (data.sub_category_id != this.subCategoryId) {
          // console.log("subcat changing...")
          this.updateSubCatId(data.sub_category_id);
        } else {
          // console.log("subcat not changed")
        }
      } else {
        if (this.selectedCategory != this.categoryId) {
          // console.log("cat changing...")
          this.updateCatId(this.selectedCategory);
        } else {
          // console.log("cat not changed")
        }
      }
    },
    fetchCategoryData(loader = null) {
      const data = {
        categorytype: "market price",
      };

      if (loader) {
        // console.log("loader on categories")
        this.isLoading = true;
      } // Set isLoading to true to show the loading spinner

      axios
        .post("https://vaiyal-app.herokuapp.com/categorytype", data)
        .then((response) => {
          this.categories = response.data.data;
          console.log("this.categories", this.categories);
          if (response.data.status == "success") {
            this.categories = [];
            response.data.data.map((category) => {
              if (category.isdatafound) {
                this.categories.push(category);

                if (
                  category.category_name.replace(/\s+/, "-").toLowerCase() ==
                  this.$route.params?.categoryName
                ) {
                  this.selectedCategory = category.category_id;
                  this.selectedProduct = category.tn_name;
                }
              }
            });
            // console.log("response.data.data",response.data.data)

            //TODO: if cat in params, run this loop.
            for (let category of this.categories) {
              if (
                category.category_name.replace(/\s+/, "-").toLowerCase() ==
                this.$route.params?.categoryName
              ) {
                this.selectedCategory = category.category_id;
                this.selectedProduct = category.tn_name;
                break;
              }
            }
            // console.log('loader cat 1')
            if (!this.$route.params?.location) this.isLoading = false;
            this.$nextTick(() => {
              const container = this.$refs.categoryContainer;
              if (container) {
                container.scrollIntoView({ behavior: "smooth" });
              }
            });
          }
        })
        .catch((error) => {
          console.error("Post error:", error);
          // console.log('loader cat finally')
          // this.isLoading = false;
        });
    },
    async fetchMarketData() {
      try {
        if (this.selectedCategory != 0) {
          const apiUrl = `https://vaiyal-app.herokuapp.com/getdistrict?type=market&categoryid=${this.selectedCategory}`;
          const response = await fetch(apiUrl);
          const data = await response.json();

          if (data.status === "success") {
            this.markets = data.data;

     

            let change;
            this.markets.map((dist) => {
              if (
                this.$route.params.location.split("-")[1].replace(/-/g, " ") ===
                dist.market_name.toLowerCase()
              ) {
                this.marketId = dist.market_id;
                this.selectedMarket = dist.market_id;
                this.selectedDistrict = dist.tn_name;
                change = true;
              }
            });

            if (!change) {
              this.selectedMarket = "0";
            }
          } else {
            console.error("API response error:", data.msg);
          }

          this.fetchPlaceData();
        }
      } catch (error) {
        console.error("Error fetching market data:", error);
      }
    },
    async fetchInitData() {
      fetch("https://vaiyal-app.herokuapp.com/get/recentlist?type=market")
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            this.tumpData = data.data;
            this.recentCategory = data.data.categoryName;
            console.log("123AAAAA", this.tumpData);
          } else {
            console.error("Failed to fetch recent product data:", data.msg);
          }
        })
        .catch((error) => {
          console.error("Error fetching recent product data:", error);
        });
    },
    async fetchPlaceData() {
      if (this.selectedMarket) {
        try {
          const apiUrl = `https://vaiyal-app.herokuapp.com/getcities?type=market&categoryid=${this.selectedCategory}&marketid=${this.selectedMarket}`;
          const response = await fetch(apiUrl);

          const data = await response.json();
          if (data.status === "success") {
            this.isPlaceDataFetched = true;
            this.placeData = [];
            this.placeData = data.data;
            let change;
            for (let i of data.data) {
              if (
                i.place.toLowerCase() ==
                this.$route.params?.city?.replace(/-/g, " ")
              ) {
                change = true;
                if (this.selectedPlace != i.market_place_id) {
                  // console.log("mpId 2 changing...")
                  this.selectedPlace = i.market_place_id;
                  // this.updateMarketPlaceId(i.market_place_id)
                  break;
                }
              } else {
                // console.log("mpId 2 not changed", this.selectedPlace, i.market_place_id)
                // if (reset) this.selectedPlace = '0'
              }

              // this.selectedPlace = i.market_place_id
              // this.updateMarketPlaceId(i.market_place_id)
              // change = true;
            }
            if (!change) {
              if (this.selectedPlace != "0") {
                // console.log('mpId to 0 (1)',reset)
                this.selectedPlace = "0";
              }
            }
          } else {
            console.error("API response error:", data.msg);
          }
        } catch (error) {
          console.error("Error fetching place data:", error);
        }
      } else {
        this.placeData = []; // Reset placeData if no market is selected
        this.selectedPlace = "0"; // Reset selectedPlace
        // console.log('mpId to 0 (2)')
      }
    },

    fetchSublistData() {
      this.isLoading = true;

      const apiUrl = `https://vaiyal-app.herokuapp.com/getplacemarket?page=${this.currentPage}`;
      const payload = {
        categoryid: this.selectedCategory,
        marketid: this.selectedMarket,
        marketplaceid: this.selectedPlace,
        created: this.created,
      };

      axios
        .post(apiUrl, payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.sublistData = response.data.data.Dates; // All data
            console.log("this.sublistData",this.sublistData)
            this.totalItems = response.data.data.totalItems; // Total items (from API)
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.content = response.data.data.content;
            this.disclaimer = response.data.data.disclaimer
            this.updatePaginatedData();
                 
          } else {
            console.error("API Error:", response.data.msg);
          }
        })
        .catch((error) => {
          console.error("sublist:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async updateMetaTags() {
      const categoryName = this.$route.params.categoryName;
      const pageName = "pricesublist";
      const city = this.$route.params.city;
      const district =
        this.$route.params.location?.split("-")[1] || "Tamilnadu";
      const created = this.created;

      const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const formattedCreatedDate = formatDate(created);
      console.log("formattedCreatedDate", formattedCreatedDate);
      const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      const capitalizedCity = capitalizeFirstLetter(city || "");
      const capitalizedDistrict = capitalizeFirstLetter(district || "");

      try {
        const response = await axios.get(
          "https://vaiyal-app.herokuapp.com/meta",
          {
            params: {
              category_name: categoryName,
              page_name: pageName,
            },
          }
        );

        const metaData = response.data.data;

        if (metaData) {
          const title = metaData.title
            .replace(
              "{city}",
              this.$route.params.city ? capitalizedCity + "," : ""
            )
            .replace("{district}", capitalizedDistrict);
          document.title = title;

          const description = metaData.description
            .replace(
              "{city}",
              this.$route.params.city ? capitalizedCity + "," : ""
            )
            .replace("{district}", capitalizedDistrict)
            .replace("{date}", formattedCreatedDate);
          const metaDescription = document.querySelector(
            'meta[name="description"]'
          );
          if (metaDescription) {
            metaDescription.setAttribute("content", description);
          }
          const head = metaData.title
            .replace(
              "{city}",
              this.$route.params.city ? capitalizedCity + "," : ""
            )
            .replace("{district}", capitalizedDistrict);
          const metaHead = document.querySelector('meta[name="title"]');
          if (metaHead) {
            metaHead.setAttribute("content", head);
          }

          const canonicalLink = document.querySelector('link[rel="canonical"]');
          const canonicalHref = `https://vayalagro.com/market-price/${categoryName}`;
          if (canonicalLink) {
            canonicalLink.setAttribute("href", canonicalHref);
          } else {
            const linkElement = document.createElement("link");
            linkElement.setAttribute("rel", "canonical");
            linkElement.setAttribute("href", canonicalHref);
            document.head.appendChild(linkElement);
          }
        }
      } catch (error) {
        console.error("Error fetching meta data:", error);
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "Home") {
      window.location.reload();
    } else {
      next();
    }
  },
};
</script>

<style>
@import url("/src/components/CategoryPage.scss");
@import url("/src/components/Ads.scss");
@import url("/src/components/Marketprice.scss");



</style>
